import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/estoques/Estoques.module.css'
import Header from '../../components/Header';
import Link from '../../components/Link';
import PageTitle from '../../components/PageTitle';

function Conferencia() {
    const navigate = useNavigate();
    const permissoes = JSON.parse(localStorage.getItem('permissoes'));

    return (
        <div className={styles.body}>
            <Header />

            <Link redirectTo="/home" />

            <PageTitle src="/images/common/caixa.svg" title="Estoques" />

            <div className={styles.linksEstoques}>
                {permissoes.estoques.subpaginas_permitidas.includes("relatorio") && (
                    <button onClick={() => navigate('/estoques/relatorio')}>
                        <img src="images/common/relatorio.ico" alt="" />
                        <p>Relatório</p>
                    </button>
                )}

                {permissoes.estoques.subpaginas_permitidas.includes("dashboard") && (
                    <button onClick={() => navigate('/estoques/dashboard')}>
                        <img src="images/common/dashboard.svg" alt="" />
                        <p>Dashboard</p>
                    </button>
                )}

                {permissoes.estoques.subpaginas_permitidas.includes("conferencia") && (
                    <button onClick={() => navigate('/estoques/conferencia')}>
                        <img src="images/common/leitor.png" alt="" />
                        <p>Conferência</p>
                    </button>
                )}
            </div>
        </div>
    )
}

export default Conferencia;